import Vue from 'vue'
import App from './App.vue'
import VueFire from 'vuefire'
import rg4js from 'raygun4js'
// @ts-ignore
import VueYoutube from 'vue-youtube'

import { auth } from './firebaseApp'
import i18n from '@/services/Translations'

declare global {
  interface Window {
    config: any;
  }
}
window.config = window.config || {}

Vue.config.productionTip = false
Vue.use(VueFire)
Vue.use(VueYoutube)

// Enable when using the simulator
//firebaseApp.functions('europe-west1').useFunctionsEmulator('http://localhost:5001')

// Setup Raygun
rg4js('apiKey', 'pBPyfXe5ytSDTGuuoh1YOg')
rg4js('enableCrashReporting', true)

// @ts-ignore
if (process.env.NODE_ENV === 'development') {
  rg4js('options', {
    allowInsecureSubmissions: true,
    debugMode: false,
  })
}

Vue.config.errorHandler = (err, vm, info) => {
  // @ts-ignore
  if (process.env.NODE_ENV === 'development') {
    console.error(err);
  } else {
    rg4js('send', {
      error: err,
      customData: [{ info: info }],
    })
  }
}

let app: Vue | null
// Wait for firebase to sync the user auth once, before rendering Vue
auth.onAuthStateChanged(user => {
  if (!app) {
    app = new Vue({
      i18n: i18n,
      render: h => h(App),
    }).$mount('#app')
  }
})
